import { takeLatest, put, select, call } from 'redux-saga/effects';
import {
    GET_RENEWAL_CONFIG_REQUEST, getRenewalConfigSuccess, getRenewalConfigFailure,
    UPDATE_RENEWAL_CONFIG_REQUEST, updateRenewalConfigSuccess, updateRenewalConfigFailure,
} from '../actions/renewalConfigs';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { getRenewalConfig, updateRenewalConfig } from '../services/renewalConfigs';

const getRenewalConfigWorker = function* ({ payload: { companyId } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getRenewalConfig, companyId, token);
        yield put(getRenewalConfigSuccess(response.data.renewal ?? response.data));
    } catch (err) {
        yield put(getRenewalConfigFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const updateRenewalConfigWorker = function* ({ payload: { companyId, data } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(updateRenewalConfig, companyId, data, token);
        yield put(updateRenewalConfigSuccess(response.data.renewal ?? response.data));
    } catch (err) {
        yield put(updateRenewalConfigFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export default [
    takeLatest(GET_RENEWAL_CONFIG_REQUEST, getRenewalConfigWorker),
    takeLatest(UPDATE_RENEWAL_CONFIG_REQUEST, updateRenewalConfigWorker),
];
